/**
 * @generated SignedSource<<47d4fc85015c3d659117fb957c7b3bd7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AcceptDealTransactionDetails_metadata$data = {
  readonly receivedAssetQuantities: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"DealSideItemsDisplay_assetQuantities">;
  }>;
  readonly sentAssetQuantities: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"DealSideItemsDisplay_assetQuantities">;
  }>;
  readonly " $fragmentType": "AcceptDealTransactionDetails_metadata";
};
export type AcceptDealTransactionDetails_metadata$key = {
  readonly " $data"?: AcceptDealTransactionDetails_metadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"AcceptDealTransactionDetails_metadata">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "DealSideItemsDisplay_assetQuantities"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AcceptDealTransactionDetails_metadata",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetQuantityType",
      "kind": "LinkedField",
      "name": "sentAssetQuantities",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetQuantityType",
      "kind": "LinkedField",
      "name": "receivedAssetQuantities",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "TransactionMetadataType",
  "abstractKey": null
};
})();

(node as any).hash = "f94ceb09ee153734b51d9fcf7c5cb2e4";

export default node;
